
    <div class="flex flex-col min-h-screen bg-[color:var(--background)] text-[color:var(--foreground)]">
        <app-public-header></app-public-header>
        <main class="flex-grow">
            <router-outlet></router-outlet>
        </main>
        <app-footer></app-footer>
    </div>
    
